import type { Components } from '@mui/material/styles';

export default function MUIPaper(): Components['MuiPaper'] {
  return {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  };
}
